<template>
    <div class="location-panel" ref="main">
        <geocoder v-on:foundgeocode="foundgeocode" />
        <div class="pin-cards">
            <b-card class="pin-card" v-for="(loc, index) in locations" :key="index">
                <b-card-title>
                    <b-button variant="default" @click="loc.remove">
                        <i class="fa fa-times text-danger"></i>
                        <span class="sr-only">Remove</span>
                    </b-button>
                    <b-button class="location__title" variant="default" @click="$emit('locationSelected', loc)">
                        {{ loc.getName() }}
                    </b-button>
                    <b-badge class="location__score" v-b-tooltip.hover title="Mdory score" :class="{location__score__locked: !loc.scoreUpdate}">
                        {{loc.scoreFormatted()}}
                    </b-badge>
                    <b-button variant="default" @click="loc.edit">
                        <i class="fa fa-pencil-alt text-muted"></i>
                        <span class="sr-only">Rename</span>
                    </b-button>
                </b-card-title>

                <b-button-toolbar class="align-items-center">
                    <i class="fa fa-car mr-2 text-secondary" v-b-tooltip.hover title="Tooltip text explaining travelshed"></i>
                    <b-button-group size="sm" class="mr-auto solid" aria-label="Travelshed">
                        <b-button :class="loc.traveltime==0 ? 'active' : ''" variant="outline-danger" @click="travel(loc, 0, index)">
                            <i class="fa fa-ban"></i>
                            <span class="sr-only">None</span>
                        </b-button>
                        <b-button :class="loc.traveltime==1 ? 'active' : ''" variant="outline-primary" @click="travel(loc, 1, index)">15&thinsp;&#8725;&thinsp;<strong>30</strong></b-button>
                        <b-button :class="loc.traveltime==2 ? 'active' : ''" variant="outline-primary" @click="travel(loc, 2, index)">20&thinsp;&#8725;&thinsp;<strong>40</strong></b-button>
                    </b-button-group>

                    <b-button variant="link" class="ml-3 px-0" size="sm" @click="report(loc)">
                        <i class="fa fa-file-alt"></i>&ensp;Report
                    </b-button>
                </b-button-toolbar>
            </b-card>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    // import {Location} from "./Location.js";
    import Location from "./Location.vue";
    import geocoder from './Geocoder';

export default {
    name: 'locationpanel',
    props: ['maxLocations'],
    components: {
        Location:location,
        geocoder
    },
    mounted: function() {
        this.$on("rem", function(e)
        {
            console.log("rem here");
            console.log(e);
            this.removeLocation(e);
        });
        this.$on("removeLocation", function(e)
        {
            console.log("here");
            console.log(e);
            this.removeLocation(e);
        });
    },
    data() {
        return {
            selectedLocation: null,
            locations: [],
            htmlContent: '',
            isHidden: false,
        }
    },
    methods: {
        travel(loc, time, index) {
            let self = this;
            loc.traveltime = time;
            if(time==0)
            {
                self.$emit('cleartravelshed', {loc: loc});
            } else {
                self.$emit('travelshed', {loc: loc});
            }
            $(".travelbtn").removeClass("active");
            $("#travel_" + index + "_" + time).addClass("active");
        },
        foundgeocode(g)
        {
            let self = this;
            console.log(g);
            self.addLocation(g.point, g.point.text);
        },
        removeLocation(loc)
        {
            this.locations = this.locations.filter(function(i){
                 return i.id!=loc.id;
            });
            this.$parent.mapPinGeoJson.features = this.$parent.mapPinGeoJson.features.filter(function(f) {
                return f.properties.id != loc.id;
            });

            this.$parent.$refs.mapboxcomponent._map.getSource('mappin-source').setData(this.$parent.mapPinGeoJson);
            this.$parent.clearDriveTime(loc);
        },

        addLocation(point, name) {
            let self = this;
            if(self.locations.length>=self.maxLocations)
            {
                alert("No more than "+self.maxLocations+ " locations");
                return false;
            }
            var l = Vue.extend(Location);
            let temp = {};
            temp.point = point;
            temp.id = point.properties.id;
            console.log(' PIN POINT PROP ID ');
            console.log(point.properties);
            if(name!=undefined) {
                temp.name =  name;
            } else {
                temp.name = "Location " + (this.locations.length + 1);
            }
            temp.lat = point.geometry.coordinates[0];
            temp.lon = point.geometry.coordinates[1];
            //don't take a geo id which might be on the county layer
//            temp.geoid = point.geometry.id;
            temp.parent = self;
            var locobj = new l({data:temp});
            locobj.$mount(); // pass nothing
            this.$refs.main.appendChild(locobj.$el);

            self.$parent.mapPinGeoJson.features.push(point);
            self.$parent.$refs.mapboxcomponent._map.getSource('mappin-source').setData(self.$parent.mapPinGeoJson);


           this.locations.push(locobj);
           //if there is a currently selected location
           //lock down its score
           if (this.selectedLocation != null) {
               this.selectedLocation.scoreUpdate = false;
           }
           this.selectedLocation = locobj;
           this.$emit('locationSelected', locobj);
           return true;
        },
        report(location) {
            this.$emit('reportmodeClicked', location);
            // this.$emit('reportmodeClicked', this.selectedLocation);
        },
        setHtml(html) {
            this.htmlContent = html;
//            this.isHidden = false;
        },
        openPanel() {
            this.isHidden=false;
        },
        closePanel() {
            this.isHidden=true;
        }
    }

}
</script>

<style lang="scss">
    .badge.location__score__locked {
        font-style:italic;
        text-decoration: underline
    }
    .location-panel {
        margin-right: 2.5rem;
        bottom: 1rem;
        display: flex;
        flex-direction: column;
        left: calc(1em + 240px + 1em);
        pointer-events: none;
        position: fixed;
        right: 1rem;
        top: 1rem;
        z-index: 50;
    }

    .pin-cards {
        display: flex;
        margin-top: 1rem;

        .pin-card {
            flex: 0 1 auto;
            max-width: 480px;
            pointer-events: all;
            position: static;

            + .pin-card {
                margin-left: 1rem;
            }

            > .card-body {
                padding: .75rem .875rem;
            }
        }

        .card-title {
            align-items: center;
            cursor: pointer;
            display: flex;
            font-size: 1rem;
            margin: -.375rem -.75rem .25rem;

            img {
                height: 1.25rem;
                margin-right: .25rem;
                vertical-align: -.25rem;
            }
        }

        .location__title {
            flex: 1 0 0;
            font-weight: bold;
            overflow: hidden;
            padding-left: 0;
            padding-right: 0;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
                color: #3498db;
            }
        }

        .location__score {
            margin-left: .5rem;
        }

        .btn-toolbar {
            flex-wrap: nowrap;
            white-space: nowrap;
        }
    }
</style>
